<template>
    <div>
        <q-modal v-model="showDialog" no-backdrop-dismiss >
                <q-toolbar  style='width:1024px;'>
                    <q-toolbar-title>
                        <div class='row no-wrap justify-between items-center'>
                            <div class='col-6'>Чек-лист</div>
                            <div class='col-3 q-display-2 text-weight-bold'>{{fullNumber}}</div>
                            <div class="col-3 text-right"><q-btn color='negative' label='закрыть' @click="closeDialog"/></div>
                        </div>
                    </q-toolbar-title>
                </q-toolbar>
                <!-- список фильтров -->
                <div class='row no-wrap justify-around q-pa-sm ellipsis items-baseline' style='max-width:1000px'>
                    <div class='col-3 ellipsis q-pa-md'>
                        <q-select
                            v-model="materialFilter"
                            float-label="Фильтр по материалу"
                            multiple
                            clearable
                            separator
                            :options="materialList"
                            :display-value="filterText(materialFilter)"
                        />
                    </div>
                    <div class="col-3 ellipsis q-pa-md">
                        <q-select
                            v-model="sizeFilter"
                            float-label="Фильтр по размеру"
                            multiple
                            clearable
                            separator
                            :options="sizeList"
                            :display-value="filterText(sizeFilter)"
                        />
                    </div>
                    <div class="col-4 ellipsis q-pa-md">
                        <q-select
                            v-model="commentFilter"
                            float-label="Фильтр по макету"
                            multiple
                            clearable
                            separator
                            :options="commentList"
                            :display-value="filterText(commentFilter)"
                        />
                    </div>
                    <div class="col-2 text-right">
                        <q-btn color='positive' label='выбрать все' outline @click="checkAll"/>
                    </div>
                </div>
                <!-- спинер -->
                <div class='row items-center justify-center' style='min-height:400px;' v-if='isLoading'>
                    <q-spinner-facebook color='primary' size="60px" />
                </div>
<!-- выводим список -->
                <div class='q-pa-sm q-pt-lg q-pb-lg q-mb-md' style='width:1012px;' v-if='!isLoading' >
                    <!-- Заголовок -->
                    <div class='row no-wrap q-caption text-white bg-primary q-pa-xs q-pt-sm q-pb-sm'>
                        <div class='col-1 text-center'>Заказ</div>
                        <div class='col-2 text-center'>Материал</div>
                        <div class='col-1 text-center'>Размер</div>
                        <div class='col-1 text-center'>Количество</div>
                        <div class='col-3 text-center'>Подпись</div>
                        <div class='col-3 text-center'>Комментарии</div>
                    </div>
                    <div style='min-height:400px; max-height:400px; overflow-y: scroll; border: 1px solid lightgray;'>
                        <div v-for='(item, key) in filesList' :key=key class='myLine q-pa-xs text-faded q-body-1'>
                            <div class='row no-wrap items-center'>
                                <div class='col-1 text-center'>{{item.main_id}}</div>
                                <div class='col-2 text-center'>{{getMaterial(item)}}</div>
                                <div class='col-1 text-center'>{{getSize(item)}}</div>
                                <div class='col-1 text-center'>
                                    {{getNumber(item)}}
                                    <q-popup-edit v-model="newNumber" title="Новое количество" buttons @save='saveNewCount(item)' @show='initNumber(item)' >
                                        <q-input type="number" v-model="newNumber" @change="saveNewCount(item)"/>
                                    </q-popup-edit>
                                </div>
                                <div class='col-3 text-center ellipsis'>{{getTitle(item)}}</div>
                                <div class='col-3 text-center ellipsis'>{{getComment(item)}}</div>
                            </div>
                            <q-card-separator/>
                        </div>
                    </div>
                </div>
        </q-modal>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    name : 'checkList',

    data() {
        return {
            showDialog : false,
            isLoading : false,
            files : [],


            materialFilter : [],
            sizeFilter : [],
            commentFilter : [],
            fullNumber : 0,
            newNumber : null,
            
        }
    },
    created() {
        eventBus.$on('checkListDialog', ()=> {            
            this.showDialog = true;
            this.isLoading = true;
            this.$store.dispatch('getDetailsSelectedFiles')
                .then((data)=>{
                    this.files = data;
                    this.isLoading = false;

                    this.checkAll();                    

                })
                .catch(()=>{
                    this.isLoading = false;
                });
            
        });
    },
    beforeDestroy() {
        eventBus.$off('checkListDialog');
    },

    computed : {

        filesList() {
            // начинаем фильтровать данные
            var filtered = [];
            if (this.files != null) {
                    filtered = this.files.filter(element => {
                    let isValid = true;
                    let opt = element.options != null ? JSON.parse(element.options) : {};
                    isValid = (this.materialFilter.length > 0) ? isValid && (this.materialFilter.filter(item => {return item == opt.material;}).length > 0) : false;
                    isValid = (this.sizeFilter.length > 0) ? isValid && (this.sizeFilter.filter(item => {return item == (opt.width + ' x ' + opt.height)}).length > 0) : false;
                    isValid = (this.commentFilter.length > 0) ? isValid && (this.commentFilter.filter(item => {return item == opt.comment}).length > 0) : false;

                    return isValid;
                    
                });

                this.fullNumber = 0;
               
                filtered.forEach(element => {
                    let opt = element.options != null ? JSON.parse(element.options) : {};
                    this.fullNumber += opt.number != null ? opt.number : 0;
                });
               

            }
            return filtered;
        },

        materialList() {
            let result = [];
            if (this.files != null) {
                this.files.forEach(element => {
                    let opt = element.options != null ? JSON.parse(element.options) : {};
                    let f = result.filter(item => {
                        return item.value == opt.material;
                    });
                    if (f.length == 0) {
                        let m = this.$store.getters.getMaterialById(opt.material);
                        result.push({
                                label : m != null ? m.name : '',
                                value : opt.material,
                        });  
                    }
                });
            }
            return result;
        },

        commentList() {
            let result = [];
            if (this.files != null) {
                this.files.forEach(element => {

                    let opt = element.options != null ? JSON.parse(element.options) : {};
                    // ищем такой в списке - если нет то добавляем
                    let f = result.filter(item => {
                        return item.label == opt.comment;
                    });

                    if (f.length == 0) { // нет в списке - добавляем
                        result.push({
                                label : opt.comment,
                                value : opt.comment,
                        });
                    }
                });
            }
            return result;
        },

        sizeList() {
            let result = [];
            if (this.files != null) {
                this.files.forEach(element => {

                    let opt = element.options != null ? JSON.parse(element.options) : {};
                    let size = ((opt.height != null) && (opt.width)) ? (opt.width + ' x ' + opt.height) : '-';
                    
                    // ищем такой в списке - если нет то добавляем
                    
                    let f = result.filter(item => {
                        return item.label == (opt.width + ' x ' + opt.height);
                    });

                    if (f.length == 0) { // нет в списке - добавляем
                        result.push({
                                label : opt.width + ' x ' + opt.height,
                                value : opt.width + ' x ' + opt.height,
                        });
                    }
                });
            }
            return result;
        }
    },

    methods : {
        initNumber(item){
            console.log('init');
            let opt = item.options != null ? JSON.parse(item.options) : {};
            this.newNumber = opt.number != null ? opt.number : 0;
        },

        saveNewCount(item) {
            let q = item;
            let opt = item.options != null ? JSON.parse(item.options) : {};
            let oldNumber = opt.number;
            opt.number = this.newNumber;
            
            q.options = JSON.stringify(opt);
            this.$store.dispatch('updateFileParam', q)
            .then(data=>{
                // console.log(data);
            })
            .catch(error => {
                opt.number = oldNumber;
                q.options = JSON.stringify(opt);
                this.$admns.showNotify('Параметры не изменены', 'error','ответ сервера');
                console.log(error)
            });
        },

        checkAll() {
            this.materialFilter = [];
            this.sizeFilter = [];
            this.commentFilter = [];

            if (this.materialList.length>0) {
                this.materialList.forEach(element => {
                    this.materialFilter.push(element.value);
                });
            }
            if (this.sizeList.length>0) {
                this.sizeList.forEach(element => {
                    this.sizeFilter.push(element.value);
                });
            }

            if (this.commentList.length>0) {
                this.commentList.forEach(element => {
                    this.commentFilter.push(element.value);
                });
            }
        },
        closeDialog(){
            this.showDialog = false;
            this.files = null;
        },

        filterText(item){
            return 'Фильтр по ' +item.length+' позициям'
        },

        getNumber(item) {
            let opt = item.options != null ? JSON.parse(item.options) : {};
            return opt.number != null ? opt.number : 0;
        },
        getSize(item) {
            let opt = item.options != null ? JSON.parse(item.options) : {};
            return ((opt.height != null) && (opt.width)) ? (opt.width + ' x ' + opt.height) : '-';
        },
        getTitle(item) {
            let opt = item.options != null ? JSON.parse(item.options) : {};
            return opt.title != null ? opt.title : '';
        },
        getComment(item) {
            let opt = item.options != null ? JSON.parse(item.options) : {};
            return opt.comment != null ? opt.comment : '';
        },
        getMaterial(item) {
            let opt = item.options != null ? JSON.parse(item.options) : {};
            let matId = opt.material != null ? opt.material : null;
            let m = this.$store.getters.getMaterialById(matId);
            return m != null ? m.name : '-';
        }
    }
}
</script>
<style lang="scss" scoped>
    .myLine {
        &:hover {
            background: rgb(228, 247, 228);
        }
    }
</style>

